import { api_url } from '../config';
import jwt_decode from 'jwt-decode';

const token      = localStorage.getItem(`jwt_token`);
const project_id = localStorage.getItem(`current_project_id`);

export async function getAPI(route) {
	validateToken(token);

	const url = new URL(`${api_url}${route}`);
	url.searchParams.append(`project_id`, project_id);

	return fetch(url.toString(), {
		method  : `GET`,
		headers : {
			'Content-Type'  : `application/json`,
			'Authorization' : `Bearer ${token}`,
		},
	}).then(response => response.json());
}

export function postAPI(route, body = {}) {
	validateToken(token);

	return fetch(`${api_url}${route}`, {
		method  : `POST`,
		body    : JSON.stringify(body),
		headers : {
			'Content-Type'  : `application/json`,
			'Authorization' : `Bearer ${token}`,
		}
	}).then(response => response.json());
}

export function putAPI(route, body = {}) {
	validateToken(token);

	return fetch(`${api_url}${route}`, {
		method  : `PUT`,
		body    : JSON.stringify(body),
		headers : {
			'Content-Type'  : `application/json`,
			'Authorization' : `Bearer ${token}`,
		}
	}).then(response => response.json());
}

export function deleteAPI(route) {
	validateToken(token);

	return fetch(`${api_url}${route}`, {
		method  : `DELETE`,
		headers : {
			'Authorization' : `Bearer ${token}`,
		}
	}).then(response => response.json());
}

function validateToken(token) {
	if(!token) {
		return;
	}

	const expired = Number(jwt_decode(token)[`exp`]) * 1000 <= Date.now();

	if(expired) {
		localStorage.clear();
		window.location = `/`;
	}
}
